import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoatempotravelleronrent() {



const cardData =
{
  keyword: 'Pune to Goa Tempo Traveller on Rent',
  heading: 'Sanavi Travels: Pune to Goa Tempo Traveller on Rent',
  headingDescription: 'Sanavi Travels provides reliable Pune to Goa Tempo Traveller on Rent services for families, groups, corporate teams, and leisure travelers seeking a comfortable, well-organized, and stress-free long-distance road journey from Pune to Goa with professional drivers and flexible travel plans.',

  top: 'Top Travel Experiences on Pune to Goa Route with Tempo Traveller',

  "topPlaces": [
    {
      "title": "Scenic Pune to Goa Highway Journey",
      "description": "The Pune to Goa route is one of the most scenic long-distance road journeys in Maharashtra and the Konkan region, passing through lush green ghats, winding mountain roads, rivers, forests, and charming Konkan villages. Traveling in a Tempo Traveller allows the entire group to enjoy the journey together without the fatigue of driving multiple vehicles. Spacious seating, wide windows, and smooth suspension make the long drive comfortable even for senior citizens and children. The route becomes especially beautiful during monsoon and winter seasons, offering misty hills, waterfalls, and greenery that turn the journey itself into a memorable travel experience rather than just a transfer."
    },
    {
      "title": "Family Road Trip to Goa",
      "description": "Pune to Goa Tempo Traveller on rent is an ideal choice for family vacations where togetherness, comfort, and convenience matter the most. Families can travel at their own pace, take food or rest breaks as required, and carry sufficient luggage without space constraints. Children and elders benefit from relaxed seating and smooth travel, while families can enjoy conversations, music, and shared moments throughout the journey. This option avoids the hassle of coordinating flights or trains and allows families to reach Goa directly from their doorstep with complete flexibility."
    },
    {
      "title": "Group Travel & Friends’ Getaways",
      "description": "Goa is a popular destination for friends’ trips, bachelor parties, reunion tours, and celebration travel from Pune. Hiring a Tempo Traveller ensures that the entire group travels together safely and comfortably, avoiding the risks and confusion of convoy driving. Groups can enjoy music, snacks, planned breaks, and group bonding during the long road trip. With professional drivers handling navigation, ghats, and night driving if required, the group can relax and focus purely on enjoying the journey and the destination."
    },
    {
      "title": "Corporate Trips & Team Outings",
      "description": "Many companies plan corporate offsites, conferences, and team outings in Goa due to its resorts and relaxed environment. Pune to Goa Tempo Traveller rental offers organized and punctual transportation for corporate groups, ensuring employees travel together, reach destinations on time, and return safely. Corporate teams benefit from disciplined travel schedules, professional drivers, and comfortable seating that allows them to rest or discuss plans during transit. It also reflects a professional approach to employee travel management."
    },
    {
      "title": "Wedding & Destination Event Travel",
      "description": "Goa is a preferred destination for weddings, pre-wedding events, and destination celebrations. Tempo Traveller on rent from Pune to Goa is widely used for transporting wedding guests, family members, and event teams in a coordinated manner. It simplifies logistics, reduces transportation stress, and ensures guests arrive together and on time. Ample luggage space helps carry wedding essentials, outfits, and event materials without inconvenience."
    },
    {
      "title": "Comfortable Long-Distance Night Travel",
      "description": "For travelers preferring overnight journeys, Tempo Travellers offer stable and safe night travel options with experienced drivers familiar with the Pune–Goa highway. Comfortable seats, controlled speed, and planned halts ensure passengers can rest during the journey and reach Goa fresh. Night travel also helps save daytime hours, making it efficient for short vacation plans."
    },
    {
      "title": "Flexible Stopovers & Custom Itineraries",
      "description": "Tempo Traveller rental allows travelers to customize their Pune to Goa itinerary with stopovers at Kolhapur, Amboli Ghat, coastal viewpoints, or local food joints. This flexibility is not possible with fixed transport modes. Travelers can explore local attractions, enjoy authentic cuisine, and take scenic breaks, making the road trip richer and more personalized."
    },
    {
      "title": "Safe Travel Through Ghats & Konkan Roads",
      "description": "The route includes ghat sections and narrow Konkan roads that require skilled driving. Professional Tempo Traveller drivers are trained for such terrains, ensuring passenger safety throughout the journey. Well-maintained vehicles with strong braking systems and regular servicing add an extra layer of security, especially during monsoon travel."
    },
    {
      "title": "Budget-Friendly Group Transportation",
      "description": "For groups, hiring a Tempo Traveller from Pune to Goa is more economical than booking multiple cabs or flight tickets. Shared fuel costs, tolls, and driver expenses make it cost-effective while providing premium comfort. This makes it a preferred option for budget-conscious group travelers who do not want to compromise on comfort."
    },
    {
      "title": "Stress-Free Doorstep Pickup & Drop",
      "description": "Tempo Traveller rental offers convenient doorstep pickup from Pune and direct drop at hotels, resorts, or villas in Goa. This eliminates the need for multiple transfers, luggage handling issues, or last-mile transport arrangements, ensuring a completely hassle-free travel experience."
    }
  ],

  "services": [
    {
      "name": "Pune to Goa Tempo Traveller on Rent",
      "description": "Sanavi Travels offers specialized Pune to Goa Tempo Traveller on Rent services designed for long-distance comfort, safety, and convenience. Our Tempo Travellers are spacious, well-maintained, and ideal for families, friends, corporate teams, and event groups traveling together. The service includes professional drivers experienced on ghat roads and Konkan highways, planned rest stops, flexible departure timings, and transparent pricing. Passengers enjoy relaxed seating, ample luggage space, smooth ride quality, and complete peace of mind throughout the journey."
    },
    {
      "name": "AC Tempo Traveller Pune to Goa",
      "description": "AC Tempo Traveller services ensure a cool and comfortable environment during the long Pune to Goa road trip, especially during summer months. Air-conditioned interiors, proper ventilation, and comfortable seating help passengers remain relaxed throughout the journey. This option is highly preferred by families, corporate groups, and premium travelers seeking extra comfort during long hours of travel."
    },
    {
      "name": "Non AC Tempo Traveller Pune to Goa",
      "description": "Non AC Tempo Traveller rentals are suitable for travelers looking for economical travel options during pleasant weather conditions. These vehicles offer the same spacious seating, safety, and reliability while keeping travel costs under control, making them ideal for budget group trips and student tours."
    },
    {
      "name": "12 Seater Tempo Traveller Pune to Goa",
      "description": "12 seater Tempo Travellers are perfect for small families and compact groups who want privacy, comfort, and flexibility. With sufficient luggage space and comfortable seating, this option balances affordability with convenience for smaller travel groups."
    },
    {
      "name": "16 Seater Tempo Traveller Pune to Goa",
      "description": "16 seater Tempo Travellers are widely chosen by medium-sized groups for Pune to Goa travel. They provide generous legroom, stable ride quality, and balanced capacity, ensuring a smooth and enjoyable journey for all passengers."
    },
    {
      "name": "20 Seater Tempo Traveller Pune to Goa",
      "description": "20 seater Tempo Travellers are ideal for large groups, corporate outings, and wedding guest transport. These vehicles allow everyone to travel together comfortably while maintaining safety, coordination, and cost efficiency over long distances."
    },
    {
      "name": "Luxury Tempo Traveller Pune to Goa",
      "description": "Luxury Tempo Travellers offer premium interiors, pushback seats, enhanced suspension, and superior ride comfort. This service is suitable for corporate executives, destination weddings, VIP travel, and travelers seeking a high-end road trip experience from Pune to Goa."
    },
    {
      "name": "Tempo Traveller for Family Pune to Goa",
      "description": "Family-friendly Tempo Traveller services focus on safety, comfort, and convenience for all age groups. Smooth driving, flexible breaks, ample luggage space, and comfortable seating make long journeys enjoyable for children and senior citizens alike."
    },
    {
      "name": "Tempo Traveller for Corporate Pune to Goa",
      "description": "Corporate Tempo Traveller rentals support organized travel for team outings, offsite meetings, and business events in Goa. Professional service, punctuality, and comfortable travel conditions ensure a productive and stress-free corporate journey."
    },
    {
      "name": "Tempo Traveller for Group Pune to Goa",
      "description": "Group travel Tempo Traveller services ensure everyone travels together, eliminating coordination issues and ensuring safety. This option enhances group bonding while providing a cost-effective and comfortable long-distance travel solution."
    },
    {
      "name": "Affordable Tempo Traveller Pune to Goa",
      "description": "Affordable Tempo Traveller packages are designed to provide maximum value without compromising safety or comfort. Transparent pricing, flexible rental plans, and reliable vehicles make this an economical choice for group travelers."
    },
    {
      "name": "Best Tempo Traveller Service Pune to Goa",
      "description": "Sanavi Travels is known for delivering reliable, punctual, and customer-focused Tempo Traveller services on the Pune to Goa route. Consistent service quality and positive customer experiences make it a trusted travel partner."
    },
    {
      "name": "Tempo Traveller with Driver Pune to Goa",
      "description": "All Tempo Traveller rentals include experienced drivers who handle navigation, traffic, ghats, and night driving with professionalism. This allows passengers to relax and enjoy the journey without any driving stress."
    },
    {
      "name": "Tempo Traveller for Wedding Pune to Goa",
      "description": "Wedding travel Tempo Traveller services ensure smooth transportation of guests, families, and wedding teams from Pune to Goa. Coordinated schedules, ample space, and reliable service simplify destination wedding logistics."
    },
    {
      "name": "Tempo Traveller for Picnic Pune to Goa",
      "description": "Tempo Travellers are ideal for extended picnic and leisure trips to Goa, allowing groups to travel comfortably, carry food and luggage easily, and enjoy the journey as part of the holiday experience."
    }
  ],

  "tableData": [
    ["Pune to Goa Tempo Traveller", "AC Tempo Traveller"],
    ["Non AC Tempo Traveller", "Luxury Tempo Traveller"],
    ["12 Seater", "16 Seater"],
    ["20 Seater", "Group Travel"],
    ["Family Trips", "Corporate Tours"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Highway Drivers", "WhyChoosedescription": "Skilled drivers familiar with Pune–Goa routes and ghat sections." },
    { "WhyChooseheading": "Comfort-Oriented Vehicles", "WhyChoosedescription": "Spacious seating and smooth ride for long-distance travel." },
    { "WhyChooseheading": "Flexible Travel Plans", "WhyChoosedescription": "Custom routes, stops, and schedules as per group needs." },
    { "WhyChooseheading": "Safety & Reliability", "WhyChoosedescription": "Well-maintained vehicles with regular safety checks." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear costs with no hidden charges." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together comfortably." },
    { "WhyChooseheading": "24/7 Support", "WhyChoosedescription": "Assistance available throughout the journey." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is known for dependable service." }
  ]
};

const faqData = [
  { question: 'Do you provide Tempo Traveller from Pune to Goa?', answer: 'Yes, Sanavi Travels offers Tempo Traveller rental services from Pune to Goa.' },
  { question: 'What seating options are available?', answer: '12, 16, and 20 seater Tempo Travellers are available.' },
  { question: 'Is AC available for Pune to Goa Tempo Traveller?', answer: 'Yes, AC Tempo Travellers are available.' },
  { question: 'Are drivers experienced on ghat roads?', answer: 'Yes, our drivers are trained and experienced on ghat and Konkan routes.' },
  { question: 'Can we customize stops during the journey?', answer: 'Yes, flexible stopovers can be planned as per your itinerary.' },
  { question: 'Is night travel safe?', answer: 'Yes, night travel is safe with experienced drivers and maintained vehicles.' },
  { question: 'Is this service suitable for families?', answer: 'Absolutely, it is ideal for families and senior citizens.' },
  { question: 'Do you offer corporate group travel?', answer: 'Yes, corporate and team travel options are available.' },
  { question: 'Is luggage space sufficient?', answer: 'Yes, Tempo Travellers have ample luggage space.' },
  { question: 'How do I book Pune to Goa Tempo Traveller?', answer: 'You can book via our website or customer support.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kulkarni',
    feedback: 'Our Pune to Goa Tempo Traveller journey with Sanavi Travels was extremely comfortable and well-managed.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Deshpande',
    feedback: 'Great driver, clean vehicle, and smooth journey. Highly recommended for group travel.',
    rating: 5
  }
];





















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];




// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Pune to Goa Tempo Traveller on Rent - Sanavi Travels",
//   "description": "Sanavi Travels offers Tempo Travellers on rent from Pune to Goa for family trips, corporate travel, group tours, weddings, and picnics. AC and Non-AC options are available in 12-seater, 16-seater, and 20-seater configurations with professional drivers at affordable rates.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.7",
//     "ratingCount": "10000+"
//   }
// };



const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/Pune-to-Goa-Tempo-Traveller-On-Rent",

  "name": "Pune to Goa Tempo Traveller on Rent",

  "serviceType": "Tempo Traveller Rental",

  "description":
    "Sanavi Travels offers Tempo Travellers on rent from Pune to Goa, including AC and Non-AC 12, 16 and 20-seater vehicles for family trips, corporate travel, group tours, weddings, picnics and outstation journeys with professional drivers.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": [
    {
      "@type": "City",
      "name": "Pune",
      "containedInPlace": {
        "@type": "State",
        "name": "Maharashtra",
        "containedInPlace": {
          "@type": "Country",
          "name": "India"
        }
      }
    },
    {
      "@type": "City",
      "name": "Goa",
      "containedInPlace": {
        "@type": "State",
        "name": "Goa",
        "containedInPlace": {
          "@type": "Country",
          "name": "India"
        }
      }
    }
  ],

  "url":
    "https://www.sanavitravels.com/Pune-to-Goa-Tempo-Traveller-On-Rent"
};









  return (
    <div>
<Helmet>
  <title>
    Pune to Goa Tempo Traveller on Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book a Tempo Traveller from Pune to Goa with Sanavi Travels. AC & Non-AC 12, 16 and 20-seater Tempo Travellers for family trips, corporate travel, group tours, weddings and picnics with professional drivers."
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/Pune-to-Goa-Tempo-Traveller-On-Rent"
  />

  <meta
    property="og:title"
    content="Pune to Goa Tempo Traveller on Rent | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Rent AC and Non-AC Tempo Travellers from Pune to Goa in 12, 16 and 20-seater options with professional drivers."
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/Pune-to-Goa-Tempo-Traveller-On-Rent"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

{/* <Helmet>
  <title>
    Call : +91 7387507373 | Pune to Goa Tempo Traveller on Rent | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Tempo Travellers from Pune to Goa with Sanavi Travels. AC & Non-AC 12, 16, and 20-seater Tempo Travellers for family trips, corporate travel, group tours, weddings, and picnics with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet> */}


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/pune-to-goa-tempo-traveller-on-rent.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoatempotravelleronrent;